import { useLayoutEffect } from 'react';
export function useLockBodyScroll(active) {
    useLayoutEffect(function () {
        if (active) {
            document.body.style.overflow = 'hidden';
            return function () { return (document.body.style.overflow = 'visible'); };
        }
        return function () { };
    }, [active]);
}
//# sourceMappingURL=useLockBodyScroll.js.map